export default "__VITE_ASSET__DZ1kk2SP__"